export class FileStoreUtils {
    /**
       * returns the icon for the contenttype
       * @param contentType 
       * @returns 
       */
    getFileIcon(contentType: string): string {
        const baseClass = 'far fa-light text-xl';
        let iconClass = '';

        switch (contentType) {
            case 'application/pdf':
                iconClass = 'fa-file-pdf';
                break;
            case 'application/msword':
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                iconClass = 'fa-file-word';
                break;
            case 'application/vnd.ms-excel':
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                iconClass = 'fa-file-excel';
                break;
            case 'application/vnd.ms-powerpoint':
            case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                iconClass = 'fa-file-powerpoint';
                break;
            case 'image/jpeg':
            case 'image/png':
            case 'image/gif':
                iconClass = 'fa-file-image';
                break;
            case 'audio/mpeg':
            case 'audio/wav':
                iconClass = 'fa-file-audio';
                break;
            case 'video/quicktime':
            case 'video/mp4':
            case 'video/x-msvideo':
                iconClass = 'fa-file-video';
                break;
            case 'application/zip':
            case 'application/x-rar-compressed':
                iconClass = 'fa-file-zipper';
                break;
            case 'text/plain':
                iconClass = 'fa-file';
                break;
            case 'text/csv':
                iconClass = 'fa-file-csv';
                break;
            default:
                iconClass = 'fa-file';
        }
        return `${baseClass} ${iconClass}`;
    }

}